import { create } from 'zustand';
import { VenueTagData } from '../../../shared/dto/EntityRepository';
import type { ResourceStatus } from '../../../shared/util/scopedResource';

const sortTagsLikeServer = (tags: VenueTagData[]): VenueTagData[] =>
  [...tags].sort((a, b) => {
    const nameComparison = a.name.localeCompare(b.name, 'ko-KR');
    if (nameComparison !== 0) return nameComparison;
    if (a.index !== b.index) return a.index - b.index;
    return a.id - b.id;
  });

interface AdminVenueTagState {
  tags: VenueTagData[];
  status: ResourceStatus;
  beginVenueTagListFetch: () => void;
  setTags: (tags: VenueTagData[]) => void;
  setVenueTagListError: () => void;
  afterCreateTag: (tag: VenueTagData) => void;
  afterUpdateTag: (tag: VenueTagData) => void;
  afterDeleteTag: (tagId: number) => void;
  clearVenueTags: () => void;
}

export const useAdminVenueTagStore = create<AdminVenueTagState>((set) => ({
  tags: [],
  status: 'idle',
  beginVenueTagListFetch: () => set((state) => (
    state.status === 'success' ? state : { status: 'loading' }
  )),
  setTags: (tags) => set({
    tags: sortTagsLikeServer(tags),
    status: 'success',
  }),
  setVenueTagListError: () => set({ status: 'error' }),
  afterCreateTag: (tag) => set((state) => ({
    tags: sortTagsLikeServer([...state.tags, tag]),
    status: 'success',
  })),
  afterUpdateTag: (tag) => set((state) => ({
    tags: sortTagsLikeServer(
      state.tags.map((current) => current.id === tag.id ? tag : current),
    ),
    status: 'success',
  })),
  afterDeleteTag: (tagId) => set((state) => ({
    tags: state.tags.filter((tag) => tag.id !== tagId),
    status: 'success',
  })),
  clearVenueTags: () => set({ tags: [], status: 'idle' }),
}));
